import { createAction } from "@reduxjs/toolkit";
import type { UpdateRefundBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateRefund = createApiThunk<void, { id: string; body: UpdateRefundBody }>(
  "refunds/updateRefund",
  async ({ id, body }: { id: string; body: UpdateRefundBody }, { extra: { adminRepository } }) => {
    return adminRepository!.updateRefund(id, body);
  },
);

export const resetUpdateRefund = createAction("refunds/resetUpdateRefund");
